import { FC } from "react";
import RightArrow from "@/public/icons/arrow-brown-400.svg";
import { scroller } from "react-scroll";
import Image from "next/image";
import VideoCard from "./VideoCard";
import Button from "@/atoms/Button";

const STATS = [
  { num: "2 yrs", label: "Fixed rent, no hikes" },
  { num: "100%", label: "Rent refunded as your deposit" },
  { num: "£0", label: "Deposit needed to move in" },
  { num: "Fixed", label: "Price to buy later, locked in" },
];

const Hero: FC = () => {
  const scrollToJourney = () => {
    scroller.scrollTo("journey", { smooth: true, duration: 100, offset: 0 });
  };

  const scrollToCalculator = () => {
    scroller.scrollTo("calculator", { smooth: true, duration: 100, offset: 0 });
  };

  return (
    <div className="flex flex-col md:flex-row items-start h-full xl:items-center w-full py-10 text-white bg-landing-blue relative px-5 lg:px-20 xl:h-fit justify-between">
      <div className="w-full md:w-auto lg:w-1/2 h-auto ">
        <h1 className="text-4xl xs:text-[44px] md:text-[56px] xl:text-[68px] leading-[1.05] font-bold">
          How does <span className="text-landing-orange block">rent-to-own</span> actually work?
        </h1>
        <p className="font-serif text-xl xl:text-2xl md:mt-4 xl:mt-7 md:leading-8 mt-7 max-w-md text-white/90">
          Rent one of our homes today, get 100% of your rent back as a deposit, and buy it later at
          a price we lock in now.
        </p>

        <div className="flex flex-col xs:flex-row items-center gap-1 xs:gap-6 mt-7 xl:mt-9 justify-normal">
          <div onClick={scrollToJourney}>
            <a
              className="inline-block  px-6 py-3 text-base font-bold text-center
             text-white transition duration-300 ease-in-out transform rounded shadow bg-landing-orange  hover:scale-105 hover:cursor-pointer"
            >
              See the 5 steps
            </a>
          </div>

          <div onClick={scrollToCalculator}>
            <a
              className="flex px-6 py-3 text-base font-bold text-center
              transition duration-300 ease-in-out text-landing-orange hover:cursor-pointer hover:scale-105"
            >
              Get your budget
              <span className="text-landing-orange ml-1">
                <RightArrow />
              </span>
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-4 grid-cols-2 gap-4 mt-11 pt-7 border-t border-white/20 max-w-md">
          {STATS.map((s) => (
            <div key={s.label} className="flex flex-col gap-1">
              <span className="text-2xl md:text-3xl font-bold text-landing-orange">{s.num}</span>
              <span className="text-sm text-white/70 max-w-[16ch]">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* extra large screen Video card */}
      <div className="hidden xl:flex max-w-[600px] w-full h-full ">
        <VideoCard />
        {/* Desktop ribbon */}
        <div className="hidden lg:block relative top-0">
          <Image
            src="/how-it-works/laptop-ribbon.svg"
            alt="Ribbon"
            width={150}
            height={400}
            className="w-auto h-40"
            priority
          />
        </div>
      </div>
      {/* small , medium and large screen Video card */}
      <div className=" w-full mt-10 md:mt-0 md:flex md:w-1/2  mx-auto xl:hidden ">
        <VideoCard />
      </div>
    </div>
  );
};

export default Hero;
